import axios from "axios";
import { useMutation } from "@tanstack/react-query";

import { Keys } from "clients/apis/_keys";
import { Routes } from "clients/apis/_routes";

import { onEditAdminRes } from "./helper";

const requestConfig = { headers: { "content-type": "multipart/form-data" } };

export const editAdmin = async (params: { id: number; data: AdminReqT }) =>
  axios.post(Routes.EDIT_ADMIN + "/" + params.id, params.data, requestConfig);

export const useEditAdmin = () =>
  useMutation({
    mutationKey: [Keys.EDIT_ADMIN_MUT],
    mutationFn: editAdmin,
    onSuccess: onEditAdminRes,
  });
